<template>
  <div class="app-modal">
    <b-modal id="modal"
             :modal-class="[content.class]"
             v-model="show_"
             data-qa="modal"
             :title=content.title
    >
      <template #modal-title>
        <dyn-slot :slot-data="slotData"><slot name="txtTitle"></slot></dyn-slot>
      </template>
      <div v-if="content.modalContentText" v-html="content.modalContentText"></div>
      <dyn-slot :slot-data="slotData"><slot name="txtContent"></slot></dyn-slot>
      <template #modal-footer>
        <div  v-if="actions" class="bookable-actions">
          <button v-for="action in actions" class="btn btn-default" :disabled="action.disabled" v-bind:key="action.type" @click="$emit(`click:${action.type}`)">
            {{action.text}}
          </button>
        </div>
        <slot name="txtAfterButton"></slot>
      </template>
    </b-modal>
  </div>
</template>

<script>

import { BModal } from 'bootstrap-vue'
import syncProperty from '@/mixins/syncProperty'

export default {
  name: 'VariableModal',
  mixins: [
    syncProperty('show', 'show_')
  ],
  components: { BModal },
  computed: {
    slotData () {
      return this.content.slotData || {}
    }
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {
          title: '',
          class: ''
        }
      }
    },
    actions: {
      type: Array,
      default: () => []
    }
  }
}

</script>
